<template>

<form
  class="mx-auto col-sm-8"
  @submit.prevent
>
  <div class="form-group" :class="{ 'has-error': errors.has('name') }">
    <label for="name">{{ $t('name') }}</label>
    <input
      type="text"
      id="name"
      name="name"
      class="form-control"
      :placeholder="$t('type_name')"
      v-model="company.name"
      v-validate="'required'"
    >
    <small v-show="errors.has('name')" class="form-text text-muted">
      {{ errors.first('name') }}
    </small>
  </div>

  <div class="form-group">
    <label for="systemmodules">{{ $t('system_modules') }}</label>

    <Multiselect
      :items="systemModules"
      :initialSelected="company.systemmodules"
      itemValue="id"
      itemText="name"
      @move="onMultiselectMove"
    />
  </div>

  <div class="form-group row">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton
        @click="save"
        :loading="isLoading"
      >
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div>
</form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Multiselect from '@/components/form/Multiselect'

export default {
  name: 'CompanyForm',
  components: {
    Multiselect,
    LoaderButton
  },
  props: {
    company: {
      type: Object,
      default: () => ({
        name: '',
        id: undefined,
        systemmodules: []
      })
    }
  },
  computed: {
    ...mapState({
      systemModules: state => state.systemModules.all,
      isLoading: state => state.company.isLoading
    })
  },
  methods: {
    ...mapActions('company', [
      'create',
      'edit',
      'cleanState'
    ]),

    onMultiselectMove (systemModules) {
      this.company.systemmodules = systemModules.map(({ id }) => id)
    },

    async save (evt, done) {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }
      const { id, name, systemmodules } = this.company
      const requestData = { name, systemmodules }
      let promiseSave
      if (id) {
        promiseSave = this.edit({ id, data: requestData })
      } else {
        promiseSave = this.create(requestData)
      }
      const result = await promiseSave
      if (result) {
        this.$router.push({ name: 'listcompany' })
      }
    }
  },
  mounted () {
    this.$store.dispatch('systemModules/fetchAll')
  },
  destroyed () {
    this.cleanState()
    this.$store.dispatch('systemModules/cleanState')
  }
}
</script>
